import React from 'react';
import I18N from '../I18N';
import API from '../API';
import { Apify } from '../Apify';
import { Col, Container, Row, Table } from 'reactstrap';
import { A, R } from '../routes';

import Butt from './Butt';
import { T } from '../traks';
import Countdown from './Countdown';
import { ProgressPie } from './Progress';

var QueuedTrades = (props) => {
	if (props.error) return null;
	if (props.queue === null || props.queue.length === 0) return <div className={props.empty_class}/>;

	let queue = [...props.queue];

	queue.sort((a,b) => {
		return a.Id - b.Id;
	});

	const rows = queue.map((qt) => {
		let waiting_element = null;
		let cancel_element = null;
		let now = Date.now()/1000;
		if (qt.CancelEffectiveTs === 0) {
			const do_cancel = () => {
				API.post("/a/cancel_queued_trade", {id: qt.Id}, () => {
					props.ctl.reload();
				});
			};
			cancel_element = <Butt className="ad_btn_sm" onClick={do_cancel}><T>Cancel</T></Butt>;
			let next_ts = qt.NextTradeTs;
			if (next_ts > now) {
				// XXX the implementation of this countdown
				// stuff is questionable because it combines
				// render-time choices with dynamic updates...
				let countdown =
					(next_ts - now) >= (60*60)
					? (<React.Fragment><Countdown end_time={next_ts}/></React.Fragment>)
					: (<React.Fragment><Countdown only_minutes end_time={next_ts}/>&nbsp;<T>minutes</T></React.Fragment>)
				waiting_element = <span><T>Trades in approx.</T>: {countdown}</span>;
			} else {
				waiting_element = (
					<React.Fragment>
						<span><T>Trade in progress</T></span><br />
						<span className="font-small"><T><strong>Note:</strong> trades in stocks with low volume can take a long time to complete.</T>
						<a target="_blank" rel="noopener noreferrer" href="https://inspiration.aktiedysten.dk/min-handel-gaar-ikke-igennem-bliv-klogere-her/">
						<span className='ad_blue_link pl-1'><T>Read more here</T></span>.</a></span>
					</React.Fragment>
				);
			}
		} else {
			cancel_element = (
				<React.Fragment>
					<span className="ad_main_red"><T>Cancels in approx.</T>: <Countdown only_minutes end_time={qt.CancelEffectiveTs}/>&nbsp;<T>minutes</T></span><br />
					<span className="font-small"><T><strong>Note:</strong> You requested a cancellation. Please note that your trade might still go through. Read more in our
					<A className="ad_main_blue" href={R.href("/faq")}>FAQ</A>.</T></span>
				</React.Fragment>
			);
		}

		const ticker_element = (
			<A className="ad_main_blue" href={R.href("/ticker/:exchange/:ticker", {exchange: qt.Exchange, ticker: qt.Ticker})}>
				{qt.StockName} ({qt.Ticker})
			</A>
		);

		let what = null;
		let progress_fraction = 0;
		switch (qt.Type) {
			case 'long': {
				// long = buy or sell depending on fields
				if (qt.BuyWithAmount > 0) {
					const orig_amount = I18N.floatval_unit(qt.BuyWithAmount, qt.BankrollNDecimals, qt.Currency);
					const current_amount = I18N.floatval_unit(qt.BuyWithAmount - qt.Progress, qt.BankrollNDecimals, qt.Currency);
					if (qt.Progress) {
						what = <T>Buy {ticker_element} for {current_amount} (was {orig_amount})</T>;
					} else {
						what = <T>Buy {ticker_element} for {current_amount}</T>;
					}
					progress_fraction = qt.Progress / qt.BuyWithAmount;
				} else if (qt.SellQuantity > 0) {
					const orig_sale_amount = I18N.floatval(qt.SellQuantity, qt.StockNDecimals);
					const current_sale_amount = I18N.floatval(qt.SellQuantity - qt.Progress, qt.StockNDecimals);
					
					if (qt.Progress) {
						what = <T>Sell {current_sale_amount} (was {orig_sale_amount}) {ticker_element}</T>;
					} else {
						what = <T>Sell {current_sale_amount} {ticker_element}</T>;
					}
					progress_fraction = qt.Progress / qt.SellQuantity;
				}
				break;
			}

			case 'short': {
				if (qt.SellQuantity > 0) {
					const orig_sale_amount = I18N.floatval(qt.SellQuantity, qt.StockNDecimals);
					const current_sale_amount = I18N.floatval(qt.SellQuantity - qt.Progress, qt.StockNDecimals);
					if (qt.Progress) {
						what = <div><T>Short</T> {current_sale_amount} (was {orig_sale_amount}) {ticker_element}</div>;
					} else {
						what = <div><T>Short</T> {current_sale_amount} {ticker_element}</div>;
					}
				}
				break;
			}

			case 'cover': {
				if (qt.BuyWithAmount > 0) {
					const orig_amount = I18N.floatval_unit(qt.BuyWithAmount, qt.BankrollNDecimals, qt.Currency);
					const current_amount = I18N.floatval_unit(qt.BuyWithAmount - qt.Progress, qt.BankrollNDecimals, qt.Currency);
					if (qt.Progress) {
						what = <div><T>Cover</T> {ticker_element} <T>for</T> {current_amount} (was {orig_amount})</div>;
					} else {
						what = <div><T>Cover</T> {ticker_element} <T>for</T> {current_amount}</div>;
					}
				}
				break;
			}

			default:
				console.warn('Unknown trade type', qt);
				break;
		}

		let progress_pie = <td></td>;
		let div_title_percent = "";
		if (qt.Progress) {
			div_title_percent = "" + Math.round(progress_fraction*100) + "%";
			progress_pie = <td className="align-middle ad_th_1px"><div title={div_title_percent} className="ad_progress_pie"><ProgressPie value={progress_fraction}/></div></td>;
		}

		return (
			<tr key={qt.Id}>
				{progress_pie}
				<td>
				{what}
				</td>
				<td>
				{waiting_element}
				{cancel_element}
				</td>
			</tr>
		);
	});

	return (
		<Container className="px-0 py-4">
			<Row className="ad_game_box">
				<Col className="pl-2 pl-md-4" xs="12">
					<div className="pt-4 pb-3 pb-0 ad_150pct"><b><T>Trades in queue</T></b></div>
				</Col>
				<Col xs="12" className="pt-3 px-2 px-md-4">
					<Table size="sm">
						<tbody>
							{rows}
						</tbody>
					</Table>
				</Col>
			</Row>
		</Container>
	);
}

QueuedTrades = Apify("/a/trade_queue")
	.with_query_from_props(props => ({portfolio_id: props.portfolio_id}))
	.with_response_prop("queue")
	.with_4xx_prop("error")
	.with_ctl_prop()
	.with_refresh_interval(60)
	.wrap(QueuedTrades);

export default QueuedTrades;



// WEBPACK FOOTER //
// ./src/c/QueuedTrades.js